import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ProductsService } from '../services/products.service';
import { ObjectAddService } from '../Component(2D and 3D)/3D/ObjectAdd/object-add.service';
import { Select3dService } from '../services/select-3d.service';
import { EventLogService, Actions } from '../services/eventLog';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-add-trellis',
  templateUrl: './add-trellis.component.html',
  styleUrls: ['./add-trellis.component.scss']
})
export class AddTrellisComponent implements OnInit {
  @Output() step1Editer = new EventEmitter();

  trellisItems: any[] = [];
  apiUrl: string = environment.apiUrl;

  constructor(
    private productsService: ProductsService,
    private objectAddService: ObjectAddService,
    private select3dService: Select3dService,
    private eventLog: EventLogService
  ) {}

  goBack(value) {
    this.step1Editer.emit({ name: value });
  }

  itemClick(item): void {
    this.objectAddService.setEntity(item);
  }

  remove() {
    const selected = this.select3dService.getSelectedTrellis();
    selected.forEach(obj => this.eventLog.dispatch(new Actions.ObjectDeleteAction(obj)));
  }

  getItemTitle(item): string {
    return item.left_menu_alias || item.description || '';
  }

  getItemImageUrl(item): string {
    if (item.localProductImg) {
      return item.localProductImg;
    }
    if (item.localAsset && item.productImg) {
      return `/assets/images/trellis/${item.productImg}`;
    }
    return `${this.apiUrl}/containers/images/download/${item.productImg}`;
  }

  ngOnInit() {
    this.productsService.getTrellis().then(items => {
      this.trellisItems = items;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/add-trellis/add-trellis.component.ts